module.exports = __webpack_public_path__ + "img/45.3.TP.1901d45d.png";